/**
 * Telegram WebApp Haptic Feedback
 * Unified haptic feedback hook for all components
 */

export type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
export type NotificationStyle = "success" | "error" | "warning";
export type HapticType = ImpactStyle | NotificationStyle | "selection";

/**
 * Trigger haptic feedback via Telegram WebApp API
 */
export function haptic(type: HapticType = "light"): void {
  const tg = window.Telegram?.WebApp;
  if (!tg?.HapticFeedback) return;

  if (type === "selection") {
    tg.HapticFeedback.selectionChanged();
  } else if (type === "success" || type === "error" || type === "warning") {
    tg.HapticFeedback.notificationOccurred(type);
  } else {
    tg.HapticFeedback.impactOccurred(type);
  }
}

